import React, { Fragment } from "react";

import NavBar from "../components/NavBar"

function Documentation() {
  return (
    <Fragment>
      <NavBar />
      <div className="documentation-container">Not documentation yet</div>
    </Fragment>
  );
}

export default Documentation;
